
import { defineComponent, PropType, ref, watch } from 'vue'
import { CtClient } from '@/models/interfaces/content-type'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'

export default defineComponent({
  name: 'PaymentDetails',
  components: { EditableBlockInput, EditableBlock },
  props: {
    client: {
      type: Object as PropType<CtClient>,
      required: true,
    },
  },
  emits: ['update:client'],
  setup (props) {

    const paymentDetails = ref(props.client.financial ?? {})

    watch(() => props.client, () => {
      paymentDetails.value = props.client.financial ?? {}
    })

    const formatIBAN = (iban) => {
      if (typeof iban !== 'string') return ''
      // Remove any spaces from the input string
      iban = iban.replace(/\s/g, '')

      // Add a space every 4 characters
      iban = iban.replace(/(.{4})/g, '$1 ')

      return iban
    }

    return {
      paymentDetails,
      formatIBAN
    }
  }
})
